import { ExprError } from '../ExprError';
import { sum } from './WindowReducers';
import { ExprValue } from '../ExprValue';
import * as Types from '../../Types';
import { validateArguments } from '../../SignatureValidation';
export var WindowSumFn;
(function (WindowSumFn) {
    WindowSumFn.Name = `WINDOW_SUM`;
    WindowSumFn.Stage = "ANALYTIC";
    WindowSumFn.Signature = `WINDOW_SUM(<expression>, [<start>, <end>])`;
    function make(callName, args, type, role) {
        return {
            name: WindowSumFn.Name,
            stage: WindowSumFn.Stage,
            data: { type, role },
            init: () => {
                return {
                    sum: 0,
                };
            },
            value: (context, ...argVals) => {
                const { frame, state } = context;
                const values = argVals[0];
                const startOffsets = argVals[1];
                const endOffsets = argVals[2];
                let value = sum(values, frame.index, startOffsets, endOffsets);
                if (value != null) {
                    value = ExprValue.asSafeNumberValue(ExprValue.parseNumber(value));
                }
                return {
                    value,
                    state,
                };
            },
        };
    }
    WindowSumFn.make = make;
    function validate(callNode, callName, args) {
        const arity = args.length;
        const sig = {
            meta: {
                name: WindowSumFn.Name,
                signature: WindowSumFn.Signature,
                location: callNode.location,
            },
            arguments: arity === 1
                ? [
                    {
                        type: "NUMERIC",
                        stages: [
                            "ANALYTIC",
                            "AGGREGATE",
                            "CONST",
                        ],
                    },
                ]
                : [
                    {
                        type: "NUMERIC",
                        stages: [
                            "ANALYTIC",
                            "AGGREGATE",
                            "CONST",
                        ],
                    },
                    {
                        type: "NUMERIC",
                        stages: [
                            "ANALYTIC",
                            "AGGREGATE",
                            "CONST",
                        ],
                    },
                    {
                        type: "NUMERIC",
                        stages: [
                            "ANALYTIC",
                            "AGGREGATE",
                            "CONST",
                        ],
                        customValidation: (node) => {
                            var _a, _b;
                            const endOffset = node;
                            const startOffset = args[1];
                            if (Types.isNumberLiteral(startOffset) &&
                                Types.isNumberLiteral(endOffset) &&
                                ExprValue.lt(endOffset.value, startOffset.value)) {
                                return [
                                    new ExprError.InvalidArgument(WindowSumFn.Name, WindowSumFn.Signature, `invalid range. <end> should be greater than <start>, saw ` +
                                        `start: ${startOffset.value} end: ${endOffset.value}`, (_b = (_a = endOffset.source) === null || _a === void 0 ? void 0 : _a.location) !== null && _b !== void 0 ? _b : callNode.location),
                                ];
                            }
                            return [];
                        },
                    },
                ],
        };
        return validateArguments(sig, args);
    }
    WindowSumFn.validate = validate;
})(WindowSumFn || (WindowSumFn = {}));
